import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <div className="hero-brand">
            <h1 className="hero-title">Chester's</h1>
            <p className="hero-subtitle">Chicken on the Run</p>
          </div>
          <p className="hero-description">
            Order delicious fried chicken right from your phone! Download our mobile app 
            and enjoy the best chicken in Springfield, MA.
          </p>
          
          <div className="app-links">
            <a 
              href="https://apps.apple.com/app/chesters-chicken" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-link app-store"
            >
              <svg className="app-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C1.79 15.25 2.51 7.59 9.08 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              <div className="app-link-text">
                <span className="app-link-subtitle">Download on the</span>
                <span className="app-link-title">App Store</span>
              </div>
            </a>
            
            <a 
              href="https://play.google.com/store/apps/details?id=com.chesters.chicken" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-link play-store"
            >
              <svg className="app-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.19,15.12L14.54,12.85L17.19,10.68L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              <div className="app-link-text">
                <span className="app-link-subtitle">Get it on</span>
                <span className="app-link-title">Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="features-container">
          <div className="feature-card">
            <div className="feature-icon">🍗</div>
            <h3>Fresh Chicken</h3>
            <p>Made fresh daily with our signature recipe</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🚀</div>
            <h3>Fast Delivery</h3>
            <p>Quick delivery through DoorDash, Uber Eats, and Grubhub</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>Easy Ordering</h3>
            <p>Order from anywhere with our mobile app</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

